import enableBindingToOthers from '../../mvvm/enableBindingToOthers';
import PropertyBindingFactory from '../../mvvm/PropertyBindingFactory';
import BabylonViewBase from './BabylonViewBase';
import Iterator from '../../core/Iterator';
import * as BABYLON from '@babylonjs/core';
import BabylonCameraPan from '../../modelling/BabylonCameraPan';
import BabylonCameraZoom from '../../modelling/BabylonCameraZoom';
import StandardProgressSource from '../../progress/StandardProgressSource';
import Urls from '../../urls/Urls';
export default class SiteView extends BabylonViewBase{
	constructor(props){
		super(props);
		const {model, babylonScene, babylonModelsManager}=props;
		this._babylonScene=babylonScene;
		this._babylonModelsManager = babylonModelsManager;
		this.initialize = this.initialize.bind(this);
		this._loadSiteModels = this._loadSiteModels.bind(this);
		this._setupControls = this._setupControls.bind(this);
		this._model = model;
		enableBindingToOthers(this);
	}
	initialize(){
		return new Promise((resolve, reject)=>{
			this._loadSiteModels().then(()=>{
				this._setupControls().then(resolve).catch(reject);
			}).catch(reject);
		});
	}
	_loadSiteModels(){
		return new Promise((resolve, reject)=>{
			const models = this._model.siteModels;
			const progressSourceLoading = this._model.progressSourceLoading;
			progressSourceLoading.clear();
			const iteratorModels = new Iterator(models);
			const progressSources = [];
			for(var nModel=0; nModel<models.length; nModel++){
				const progressSource = new StandardProgressSource();
				progressSources.push(progressSource);
				progressSourceLoading.add(progressSource);
			}
			const iteratorProgressSources = new Iterator(progressSources);
			const babylonModels = [];
			const loadNextModel= ()=>{
				if(!iteratorModels.hasNext()){
					resolve(babylonModels);
					return;
				}
				const model = iteratorModels.next();
				const progressSource = iteratorProgressSources.next();
				progressSource.progressProportion =0;
				console.log('model.quadrantsRelativePath');
				console.log(model.quadrantsRelativePath);
				this._babylonModelsManager.getNewMesh({
					code:model.code,
					objectIdNodeIdsMappings:model.objectIdNodeIdsMappings,
					quadrantsPath:Urls.getQuadrantsAbsolutePath({configuration:this._model.configuration, relativePath:model.quadrantsRelativePath}),
					standardProgressSource:progressSource
				}).then((babylonModel)=>{
					progressSource.done();
					babylonModels.push(babylonModel);
					loadNextModel();
				}).catch(reject);
			};
			loadNextModel();
		});
		
	}
	_setupControls(){
		return new Promise((resolve, reject)=>{
			this._babylonScene.defaultCamerasAndLight({attachCameraControls:false});
			new BabylonCameraPan({babylonScene:this._babylonScene});
			new BabylonCameraZoom({babylonScene:this._babylonScene, zoomSpeedFactor:8});
			this._babylonScene.startRendering();
			this._babylonScene.setCameraPosition (new BABYLON.Vector3(200,200,-200));
			resolve();
		});
	}
	_zoomChanged(value){
		
	}
}
